import { render, staticRenderFns } from "./PropertyEditor.vue?vue&type=template&id=947bff90&"
import script from "./PropertyEditor.vue?vue&type=script&lang=js&"
export * from "./PropertyEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports